const ScrollWithThumb = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="w-full overflow-x-auto scroll-smooth">
      {children}
    </div>
  );
};

export default ScrollWithThumb;